import * as React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "common/helpers/rem";

import Media from "common/components/media";
import AutolinkText from "common/components/autolinkText";
import LinkPreview from "common/components/linkPreview";
import ShavedText from "common/components/shavedText";
import Icon from "common/icons";
import PACKS from "common/icons/packs";
import { useIntl } from "react-intl";

const commonStyle = css`
  .placeholder,
  img,
  video {
    max-height: ${px2rem(160)};
    width: auto;
    max-width: 100%;
  }
  font-weight: ${props => props.theme.weightRegular};
`;

const PreviewWrap = styled.div`
  display: flex;
  align-items: center;
  ${commonStyle}
`;
const Wrapper = styled.div`
  & > * + * {
    margin-top: ${px2rem(8)};
  }
  ${commonStyle}
`;
const AttachmentIconWrap = styled.div`
  width: ${px2rem(18)};
  height: ${px2rem(18)};
  margin-left: ${px2rem(4)};
`;
const AttachmentWrapper = styled.div`
  max-height: ${px2rem(160)};
  position: relative;
  overflow: hidden;
`;

interface IProps {
  thread: Vingle.IThread;
  isPreview?: boolean;
}

const ThreadContentRenderer = ({ thread, isPreview }: IProps) => {
  const linkContent = <AutolinkText content={thread.content} />;

  if (isPreview) {
    const intl = useIntl();
    let threadContent;

    if (thread.content) {
      threadContent = <ShavedText value={linkContent} />;
    } else if (!Boolean(thread.content) && Boolean(thread.resource)) {
      threadContent = `(${intl.formatMessage({ id: "media" })})`;
    }

    let attachmentPreview = null;

    if (thread.resource) {
      let resourceIcon = null;

      if (thread.resource.type === "og-object") {
        resourceIcon = PACKS.COMMENT_INPUT.LINK;
      } else {
        resourceIcon = PACKS.COMMON.PICTURE_ICON;
      }

      attachmentPreview = (
        <AttachmentIconWrap>
          <Icon icon={resourceIcon} width={18} height={18} />
        </AttachmentIconWrap>
      );
    }

    return (
      <React.Fragment>
        <PreviewWrap>
          {threadContent}
          {attachmentPreview}
        </PreviewWrap>
      </React.Fragment>
    );
  }

  return (
    <Wrapper>
      {thread.content && linkContent}
      {thread.resource && (
        <AttachmentWrapper>
          <Media resource={thread.resource} />
        </AttachmentWrapper>
      )}

      <LinkPreviewRenderer thread={thread} />
    </Wrapper>
  );
};

const LinkPreviewRenderer = ({ thread }: { thread: Vingle.IThread }) => {
  if (!thread.resource || thread.resource.type !== "og-object") return null;
  return <LinkPreview linkPreview={thread.resource.data} />;
};

export default ThreadContentRenderer;
